export default {
	type: 'SEARCH_HEADER',
	name: 'Search header',
	allowedSections: ['main'],
	disallowedChildren: ['*'],
	category: 'Text',
	props: [{
		name: 'prefix',
		inputType: 'text',
		label: 'Search prefix',
		default: 'Results for: '
	}, {
		name: 'suffix',
		inputType: 'text',
		label: 'Search suffix',
		default: ''
	}, {
		name: 'elementType',
		inputType: 'select',
		label: 'Size',
		default: 'h1',
		values: ['h1', 'h2', 'h3', 'h4', 'h5']
	}]
};
